"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "common", {
  enumerable: true,
  get: function get() {
    return _common["default"];
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function get() {
    return _blue["default"];
  }
});
Object.defineProperty(exports, "cyan", {
  enumerable: true,
  get: function get() {
    return _cyan["default"];
  }
});
Object.defineProperty(exports, "gold", {
  enumerable: true,
  get: function get() {
    return _gold["default"];
  }
});
Object.defineProperty(exports, "gray", {
  enumerable: true,
  get: function get() {
    return _gray["default"];
  }
});
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function get() {
    return _green["default"];
  }
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function get() {
    return _red["default"];
  }
});
Object.defineProperty(exports, "highlightblue", {
  enumerable: true,
  get: function get() {
    return _highlightblue["default"];
  }
});

var _common = _interopRequireDefault(require("./common"));

var _blue = _interopRequireDefault(require("./blue"));

var _cyan = _interopRequireDefault(require("./cyan"));

var _gold = _interopRequireDefault(require("./gold"));

var _gray = _interopRequireDefault(require("./gray"));

var _green = _interopRequireDefault(require("./green"));

var _red = _interopRequireDefault(require("./red"));

var _highlightblue = _interopRequireDefault(require("./highlightblue"));